// extracted by mini-css-extract-plugin
export default {"container":"TerminalWindow_container__DEaQQ","window":"TerminalWindow_window__9UhAg","content":"TerminalWindow_content__qfCQv"};